import './Score.css';
import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';
import noop from 'lodash/noop';
import Input from '@views/Input';

export const onInpuChange = (onChange, maxlength) => (e) => {
  let value = get(e, 'target.value');
  if (value === '') {
    onChange(undefined);
  } else if (value.length <= maxlength) {
    const parsedValue = Number(value);
    if (!Number.isNaN(parsedValue)) {
      onChange(Math.max(0, parsedValue));
    }
  }
};

export const onScoreKeyDown = (e) => {
  if (e.key === '-' || e.key === 'Subtract') {
    e.preventDefault();
    return;
  }
  if (e.key === 'ArrowDown' && Number(e.currentTarget.value || 0) <= 0) {
    e.preventDefault();
  }
};

const Score = ({ onChange, maxlength, value, ...rest }) => (
  <Input
    className="Score"
    type="number"
    min={0}
    maxLength={maxlength}
    value={value == null ? '' : value}
    onFocus={(e) => e.target.select()}
    onKeyDown={onScoreKeyDown}
    onChange={onInpuChange(onChange, maxlength)}
    enterKeyHint="next"
    {...rest}
  />
);

Score.displayName = 'Score';
Score.propTypes = {
  onChange: PropTypes.func,
  maxlength: PropTypes.number,
};
Score.defaultProps = {
  onChange: noop,
  maxlength: 2,
};

export default Score;
